import * as React from "react";
import dayjs, { Dayjs } from "dayjs";
import { DatePicker, DatePickerProps } from "antd";
import { observer } from "mobx-react-lite";
import { CommonPickerMethods } from "antd/lib/date-picker/generatePicker/interface";
import { delay } from "src/common/delay";
import { onError } from "src/common/onError";
import { CellInternalBox } from "./CellInternalBox";
import { PropsCell2Editor } from "../PropsCell2";

export const Cell2DatePicker: React.FC<PropsCell2Editor<DatePickerProps>> =
  observer(({ cell, editorProps }) => {
    const { store, value, ...cellProps } = cell;
    const refBox = React.useRef<HTMLDivElement>(null);
    const refPicker = React.useRef<CommonPickerMethods>(null);

    const { cellKey } = cell;
    React.useEffect(() => {
      store.updateCell({
        ...cellProps,
        focus(select: boolean) {
          refPicker.current?.focus();
          // У пикера нет возможности выделить содержимое. Поэтому ищем вложенный инпут
          if (select) {
            const inp = refBox.current?.querySelector("input");
            if (inp instanceof HTMLInputElement) {
              inp.select();
            }
          }
        },
        blur() {
          refPicker.current?.blur();
        },
      });
    });

    // Компонент работает с датами в виде ISO-строк.
    // А так как антовый DatePicker работает с DayJs, то конвертация происходит на лету.
    const bin2str = (bin: Dayjs | null): string | null => bin?.format() ?? null;
    const [binValue, setBinValue] = React.useState<Dayjs | null>(null);
    React.useEffect(() => {
      const bv = value && typeof value === "string" ? dayjs(value) : null;
      setBinValue(bv);
      store.setSrcCellValue(cellKey, value);
    }, [value]);
    const inView = store.isViewMode(cellKey);
    const errMsg = store.errors[cellKey];

    return (
      <CellInternalBox store={store} cellKey={cellKey} pos={cell.pos}>
        <div ref={refBox}>
          <DatePicker
            // @ts-ignore
            ref={refPicker}
            {...editorProps}
            inputReadOnly={inView}
            // readOnly={inView} В версии 5.23.2, но пока 5.13.3
            style={{ width: "100%" }}
            status={errMsg ? "error" : undefined}
            value={binValue}
            open={!inView}
            onChange={(v) => {
              setBinValue(v);
              store.setCurCellValue(cellKey, bin2str(v));
            }}
            onFocus={(e) => {
              store.activate(cellKey, false);
              editorProps.onFocus?.(e);
            }}
            onClick={() => {
              store.activate(cellKey, true);
            }}
            onBlur={() => {
              store.blur(store.cellByKey(cellKey));
            }}
            onKeyDown={(e) => {
              store.onKeyDown(cellKey, e);
            }}
            onOpenChange={(open) => {
              if (!open)
                delay(1)
                  .then(() => {
                    refPicker.current?.focus();
                  })
                  .catch(onError);
            }}
          />
        </div>
      </CellInternalBox>
    );
  });
